module.exports = __webpack_public_path__ + "static/media/calendar.0b9a4348.svg";